import React from 'react';
import {
  TouchApp,
  Mouse,
  Timeline,
  ExitToApp,
  Event,
  Gesture,
} from '@mui/icons-material';
import PageviewRoundedIcon from '@mui/icons-material/PageviewRounded';

/**
 * Get icon component for activity type
 * @param {string} type - Activity type
 * @returns {JSX.Element} Icon component
 */
export const getActivityIcon = (type) => {
  switch (type) {
    case 'page_view':
      return <PageviewRoundedIcon sx={{ fontSize: 20 }} />;
    case 'interaction':
      return <TouchApp sx={{ fontSize: 20 }} />;
    case 'scroll':
      return <Mouse sx={{ fontSize: 20 }} />;
    case 'page_duration':
      return <Timeline sx={{ fontSize: 20 }} />;
    case 'session_end':
      return <ExitToApp sx={{ fontSize: 20 }} />;
    // case 'custom_event':
    //   return <Event sx={{ fontSize: 20 }} />;
    default:
      return <Gesture sx={{ fontSize: 20 }} />;
  }
};
